import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "../../../app/axios";
import { API_URL } from "../../../app/config";
import { SuccessToast } from "../../../toast/Toasts";

export const getAllMenuSectors = createAsyncThunk(
  "/Sector/SectorShowOnMenu",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Sector/SectorShowOnMenu`
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Sectors:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllTours = createAsyncThunk(
  "/Tour/TourList",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Tour/TourList`,
        formData
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Tours:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllRoomTypes = createAsyncThunk(
  "RoomType/FindAllRoomType",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/RoomType/FindAllRoomType`,
        {
          RoomType: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Room Types:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getTourDetails = createAsyncThunk(
  "Tour/TourDetails",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Tour/TourDetails`,
        formData
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Tour Details:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const insertInquiry = createAsyncThunk(
  "TourServices/InsertWebsiteInquiry",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TourServices/InsertWebsiteInquiry`,
        formdata
      );
      SuccessToast(response.data?.Data?.Details || "Success");
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error inserting inquiry:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
